import Axios, { AxiosRequestConfig } from 'axios'
import { CookieHelper } from 'Utils/cookieHelper'
import { COOKIE_KEYS } from 'Consts/cookies.enum'

function authRequestInterceptor(config: AxiosRequestConfig) {
  const { getCookie } = CookieHelper()

  const token = getCookie(COOKIE_KEYS.TOKEN)
  config.headers = config.headers ?? {}
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers.Accept = 'application/json'
  return config
}

export const bzAxios = Axios.create({
  baseURL: process.env.REACT_APP_BOTZA,
})

bzAxios.interceptors.request.use(authRequestInterceptor)
